export const enTr = {
  site_name: 'Visa',
  order_summary: 'Order ID',
};
